import homeColor from './homeColor.vue'

export const homeData = [
  {
      "label": "渠道",
        sortable: true,

      "value": '1,channel'
  },
  // {
  //     "label": "OS",
  //     "value": '2,os'
  // },
  {
    label: '投放金额',
    sortable: true,
    sortMethod: (func, type) => {
      func(1, type, 'cost')
    },
    width: 120,
    value: '3,cost'
  },
  {
    label: '染色人数',
    value: '4,activation'
  },
  // {
  //     "label": "注册",
  //     "value": '5,registrationCount',
  //     disabled: true
  // },
  {
    label: '染色成本',
    needCalc: true,
    calc: {
      type: '/',
      data: ['cost', 'activation']
    },
    value: '6,activationCost'
  },
  {
    label: '付费率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['timePayUserNum', 'colorUserNum']
    },
    value: '37,payRate',
    render: (h, params) => {
      return (
        <div>
          {params.row.payRate
            ? (Number(params.row.payRate) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '支付成功率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['paySuccessNum', 'payNum']
    },
    width: 120,
    value: '36,paySuccessRate',
    render: (h, params) => {
      return (
        <div>
          {params.row.paySuccessRate
            ? (Number(params.row.paySuccessRate) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '独立付费用户数',
    width: 200,
    value: '34,timePayUserNum'
  },
  {
    label: '独立用户付费成本',
    width: 200,
    needCalc: true,
        calc: {
            type: '/',
            data: ['cost','timePayUserNum']
        },
    value: '33,timePayUserCost'
  },
  {
    label: '付费次数',
    width: 120,
    value: '35,payNum'
  },
  // {
  //     "label": "注册成本",
  //     needCalc: true,
  //     calc: {
  //         type: '/',
  //         data: ['cost','registrationCount']
  //     },
  //     "value": '7,registrationCost',
  //     disabled: true
  // },
  {
    label: '首日新增充值人数',
    value: '8,firstRechargeCount'
  },
  {
    label: '首日付费成本累计',
    needCalc: true,
    calc: {
      type: '/',
      data: ['cost', 'firstRechargeCount']
    },
    value: '9,firstCostCount'
  },
  {
    label: '首日新增充值金额',
    value: '10,firstRechargeCost'
  },
  {
    label: '首日付费率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['firstRechargeCount', 'activation']
    },
    value: '11,firstPayRate',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstPayRate
            ? (Number(params.row.firstPayRate) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '首日付费ARPU',
    needCalc: true,
    calc: {
      type: '/',
      data: ['firstRechargeCost', 'firstRechargeCount']
    },
    value: '12,firstARPU'
  },
  {
    label: '首日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['firstRechargeCost', 'cost']
    },
    value: '13,firstROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.firstROI
            ? (Number(params.row.firstROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '3日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['thirdRecharge', 'cost']
    },
    value: '14,thirdROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.thirdROI
            ? (Number(params.row.thirdROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '8日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['eighthRecharge', 'cost']
    },
    value: '101,eighthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthROI
            ? (Number(params.row.eighthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '15日回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['fifthRecharge', 'cost']
    },
    value: '102,fifthROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthROI
            ? (Number(params.row.fifthROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '累计回本率',
    needCalc: true,
    calc: {
      type: '/',
      unit: '%',
      data: ['allRecharge', 'cost']
    },
    value: '15,totalROI',
    render: (h, params) => {
      return (
        <div>
          {params.row.totalROI
            ? (Number(params.row.totalROI) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    label: '当日总充值金额',
    value: '20,totalRecharge'
  },
  {
    label: '累计3日充值金额',
    value: '104,thirdRecharge'
  },
  {
    label: '累计8日充值金额',
    value: '106,eighthRecharge'
  },
  {
    label: '累计15日充值金额',
    value: '108,fifthRecharge'
  },
  {
    label: '累计30日充值金额',
    value: '110,thirtyRecharge'
  },
  {
    label: '累计60日充值金额',
    value: '112,sixtyRecharge'
  },
  {
    label: '3日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['thirdRecharge', 'firstRechargeCost']
    },
    value: '105,threeTimesGrowth'
  },
  {
    label: '8日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['eighthRecharge', 'firstRechargeCost']
    },
    value: '107,eightTimesGrowth'
  },
  {
    label: '15日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['fifthRecharge', 'firstRechargeCost']
    },
    value: '109,fourthTimesGrowth'
  },
  {
    label: '30日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['thirtyRecharge', 'firstRechargeCost']
    },
    value: '111,thirtyTimesGrowth'
  },
  {
    label: '60日增长倍数',
    needCalc: true,
    calc: {
      type: '/',
      data: ['sixtyRecharge', 'firstRechargeCost']
    },
    value: '113,sixtyTimesGrowth'
  }
  // {
  //     "label": "毛利",
  //     "value": '21,gross',
  //     disabled: true
  // },
  // {
  //     "label": "DAU",
  //     "value": '22,dau',
  //     disabled: true
  // },
  // {
  //     "label": "次日留存",
  //     "value": '23,day1Retention',
  //     disabled: true
  // },
  // {
  //     "label": "3日留存",
  //     "value": '24,day3Retention',
  //     disabled: true
  // }
]

export default homeColor
